__turbopack_context__.v({
  "actionsContainer": "zC5HOa_actionsContainer",
  "applyButton": "zC5HOa_applyButton",
  "arrowDown": "zC5HOa_arrowDown",
  "button": "zC5HOa_button",
  "crossIcon": "zC5HOa_crossIcon",
  "labelCopy": "zC5HOa_labelCopy",
  "labelCopyAi": "zC5HOa_labelCopyAi",
});
